import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Extortion",
  "description": "",
  "published": "2007-05-16T00:00:00.000Z",
  "redirect_from": ["/blog/extortion/swizec/211"],
  "categories": "food for thought",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Why is it that books are sold with huge extortionate prices attached to them? Is there an explanation for this trend at all, I surely wouldn't know. But the gist of the matter is that books published in Slovenia are simply much too expensive for people to even consider buying and then everyone complains that our book market is going down the drain. Duh?`}</p>
    <p>{`Let's do a little examplifying shall we. I was recently forced into buying a local book called Pimlico by Dekleva. All fine and well, it was after all for a very important grade. But what's this? The poor paperback 161 page thing cost me what? 14,56€? What the hell, why? No idea. But I do know that a book ordered from America, with included shipping a bookstore add-on, local book tax, a world best seller from a well established author, in paperback, cost me a mere 7€. It was Memnoch the Devil by Anne Rice (434 pages) if you want to know.`}</p>
    <p>{`Why does this difference exist when that's clearly lewd. A book that was published by a publisher in my own bloody city cost twice as more than a book published half the world away. Is there no justice, no sense of reality, or are we as a nation simply stupid for even being willing to pay so much for a fucking book?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      